"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _ = require('lodash');
var _require = require('../../common/constant/role.constant'),
  INSPECT_ADMIN = _require.INSPECT_ADMIN,
  INSPECT_INSPECTOR = _require.INSPECT_INSPECTOR,
  INSPECT_MANAGER = _require.INSPECT_MANAGER,
  INSPECT_ROUTING_GROUP_MANAGER = _require.INSPECT_ROUTING_GROUP_MANAGER,
  INSPECT_SAFETY_COORDINATOR = _require.INSPECT_SAFETY_COORDINATOR,
  INSPECT_SUPER_USER = _require.INSPECT_SUPER_USER;
module.exports = /*@ngInject*/function ($resource, $q, $window, PreferenceService, ConfigService, LokiService) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  var service = $resource("".concat(INSPECT_URL, "/api/profile"), {});
  service.CURRENT_PROFILE_TOKEN = 'INSPECT_PROFILE';
  service.roles = {
    AUTHORIZED_USER: 'Authorized User',
    RESPONSIBLE_PERSON: 'Responsible Person',
    DELEGATE: 'Delegate'
  };
  service.refreshProfile = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(opt, callback) {
      var option, cache, handleResponse;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            handleResponse = function _handleResponse(profile) {
              _.each(profile.bundles, function (item) {
                // eslint-disable-next-line no-param-reassign
                item._id = profile._id;
              });
              service.setProfile(profile);
              if (callback) {
                return callback(profile);
              }
              return Promise.resolve(profile);
            };
            option = opt || {};
            cache = service.getProfile();
            if (!(cache && !option.latest)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", Promise.resolve(cache));
          case 5:
            return _context.abrupt("return", service.get({}, handleResponse).$promise);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  service.getProfile = function () {
    var value = $window.localStorage.getItem(service.CURRENT_PROFILE_TOKEN);
    return value ? JSON.parse(value) : null;
  };
  service.setProfile = function (profile) {
    $window.localStorage.setItem(service.CURRENT_PROFILE_TOKEN, JSON.stringify(profile));
    return profile;
  };
  service.hasRole = function (role) {
    var profile = service.getProfile();
    return profile ? profile.roles.some(function (profileRole) {
      return profileRole.role === role;
    }) : false;
  };
  service.isInspector = function (configuration) {
    var profile = service.getProfile();
    if (configuration) {
      return profile && profile.roles.some(function (profileRole) {
        return profileRole.role === INSPECT_INSPECTOR && profileRole.target.id && profileRole.target.id === configuration.program;
      });
    }
    return service.hasRole(INSPECT_INSPECTOR);
  };
  service.isAdmin = function () {
    return service.hasRole(INSPECT_ADMIN);
  };
  service.isAdminForProgram = function (programId) {
    var profile = service.getProfile();
    return profile && profile.roles.some(function (profileRole) {
      return profileRole.role === INSPECT_ADMIN && profileRole.target.id === programId && profileRole.target.type === 'PROGRAM';
    });
  };
  service.isSuperUser = function () {
    return service.hasRole(INSPECT_SUPER_USER);
  };
  service.isManager = function (configuration) {
    var profile = service.getProfile();
    if (configuration) {
      return profile && profile.roles.some(function (profileRole) {
        return profileRole.role === INSPECT_MANAGER && profileRole.target.source && profileRole.target.source.id === configuration.party;
      });
    }
    return service.hasRole(INSPECT_MANAGER);
  };
  service.isSafetyCoordinator = function () {
    var profile = service.getProfile();
    return profile && profile.roles.some(function (userRole) {
      return userRole.role === INSPECT_SAFETY_COORDINATOR;
    });
  };
  service.isManagerForParty = function (partyId) {
    var profile = service.getProfile();
    return profile && profile.roles.some(function (userRole) {
      return userRole.role === INSPECT_MANAGER && userRole.target.id === partyId;
    });
  };
  service.isSafetyCoordinatorForParty = function (partyId) {
    var profile = service.getProfile();
    return profile && profile.roles.some(function (userRole) {
      return userRole.role === INSPECT_SAFETY_COORDINATOR && userRole.target.id === partyId;
    });
  };
  service.hasRoleInInspect = function () {
    return service.isInspector() || service.isManager() || service.isAdmin() || service.isSafetyCoordinator() || service.isRoutingGroupMember();
  };
  service.isRoutingGroupForConfig = function (configuration) {
    var profile = service.getProfile();
    return profile && profile.roles.some(function (userRole) {
      return userRole.role === INSPECT_ROUTING_GROUP_MANAGER && userRole.target.routingGroup === configuration.routingGroup;
    });
  };
  service.isRoutingGroupMember = function () {
    var profile = service.getProfile();
    return profile && profile.roles.some(function (userRole) {
      return userRole.role === INSPECT_ROUTING_GROUP_MANAGER;
    });
  };
  service.hasManagerInspection = function (configuration) {
    var profile = service.getProfile();
    if (configuration) {
      return profile && _.some(profile.configurations, {
        _id: configuration._id,
        managerInspection: true
      });
    }
    return profile && _.some(profile && profile.configurations, {
      managerInspection: true
    });
  };
  service.isCurrentUser = function (user) {
    var profile = service.getProfile();
    return profile && profile.userId === user.userId;
  };
  service.logout = function (cb) {
    LokiService.clearAllData(function () {
      PreferenceService.clear('lastSynced');
      var inspectPreference = PreferenceService.get();
      $window.localStorage.clear();
      $window.sessionStorage.clear();
      $window.localStorage.setItem('inspect-preference', JSON.stringify(inspectPreference));
      return cb({
        ok: 1
      });
    });
  };
  service.redactInspectorsOnPrint = function () {
    var profile = service.getProfile();
    return profile && profile.campusCode === 'CDPH';
  };
  return service;
};